import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';

const states = {
  INVALID: {
    class: 'error',
    icon: 'error'
  },
  DEPOSITOR_SERVICE_DEACTIVATED: {
    class: 'error',
    icon: 'error'
  },
  WARNING: {
    class: 'warning',
    icon: 'check'
  },
  VALID: {
    class: 'valid',
    icon: 'check'
  },
  UNKNOWN: {
    class: 'empty',
    icon: 'question-mark'
  },
  AWAITING_VERIFICATION: {
    class: '',
    icon: 'clock'
  },
  EMPTY: {
    class: 'empty',
    icon: 'info'
  }
};

function DossierStateCell(props) {
  const Tag = props.tag;

  if (props.state === 'NULL') {
    return (<Tag><div/></Tag>);
  }

  const state = states[props.state];

  return (
    <Tag
      className={`dossier-state ${state ? state.class : ''}`}
      style={props.tag === 'td' ? {width: 300} : {}}
      data-id="root"
    >
      <div className="flex-container">
        <Icon icon={state ? state.icon : 'loader'}/>
        <Translate
          className="paragraph-dark"
          value={state ? `dossier.state.${props.state}.shortLabel` : ''}
        />
      </div>
    </Tag>
  );
}

DossierStateCell.defaultProps = {
  tag: 'td'
};

DossierStateCell.propTypes = {
  state: PropTypes.string,
  tag: PropTypes.oneOf(['td', 'div'])
};

export default DossierStateCell;
